<div class="navigation">
  <div class="navigation__prepend">
    <div class="navigation-title">Menu</div>
  </div>

  <div class="navigation__content">
    <div class="list">
      <ng-container *ngFor="let item of items">
        <div class="list-group" *ngIf="item.showInMenu " #ref>
          <!-- routerLinkActive="list-item-active" -->
          <div class="list-item list-item-link" [routerLink]="item.children?.length ? [] : item.url"
            (click)="toggle(ref, item, item.url)">
            <div class="list-item__overlay"></div>
            <div class="list-item__underlay"></div>
            <!-- ICON -->
            <div class="list-item__prepend">
              <i [ngClass]="item.icon" class="icon"></i>
            </div>
            <!-- CONTENT -->
            <div class="list-item__content">
              <div class="list-item-title">
                {{item.title}}
              </div>
            </div>
            <!-- ICON TOGGLE -->
            <div class="list-item__append" *ngIf="item.children && item.children.length > 0">
              <i class="fas fa-angle-down icon" [@indicatorSlide]="getExpandedState(ref)">
              </i>
            </div>
          </div>

          <!-- CHILDRENS -->
          <div *ngIf="item.children && item.children.length > 0" class="list-group__items"
            [@slide]="getExpandedState(ref)">

            <ng-container *ngFor="let children of item.children">
              <a class="list-item list-item-link list-item-children" *ngIf="item.showInMenu" [routerLink]="children.url"
                (click)="toggle(ref,item, item.url)">
                <span class="list-item__overlay"></span>
                <span class="list-item__underlay"></span>
                <!-- ICON -->
                <div class="list-item__prepend">
                  <span class="icon"></span>
                </div>
                <div class="list-item__content">
                  <span class="list-item-title list-item-title--children">
                    {{children.title}}
                  </span>
                </div>
              </a>
            </ng-container>
          </div>
        </div>
        <div class="list-group"
          *ngIf="item.showInMenu && item.title === 'Analítica' && item.url == 'https://lookerstudio.google.com/reporting/afbf495b-027a-46b9-9e57-5ee893b5e4e1/page/p_5rgxf36amc'"
          #ref>
          <div class="list-item list-item-link">
            <div class="list-item__overlay"></div>
            <div class="list-item__underlay"></div>
            <!-- ICON -->
            <div class="list-item__prepend">
              <i [ngClass]="item.icon" class="icon"></i>
            </div>
            <a style="text-decoration: none; color: white;"
              href="https://lookerstudio.google.com/reporting/afbf495b-027a-46b9-9e57-5ee893b5e4e1/page/p_5rgxf36amc"
              target="_blank">Analítica</a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="navigation__append">
    <div class="text-privacy">
      Aviso de privacidad
    </div>
    <div class="text-rights-reserved">
      Copyright © Todos los Derechos Reservados 2023
    </div>
  </div>
</div>